<div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select [class.ng-select-fill]="!tableStyle" [formControl]="fc" [placeholder]="field.name" appendTo="body">
        @for (user of users$ | async; track user.id) {
            <ng-option [value]="user.id">
                {{ user.name }}
            </ng-option>
        }
    </ng-select>
    <mat-error [control]="fc"></mat-error>
</div>
